import type { ReactElement } from 'react';

export function Services(): ReactElement {
  return <></>;
}